import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import profileImage from '../assets/images/1004753148.jpg';
import barkarLogo from '../assets/logos/barkar.png';
import mangaRaiserCover from '../assets/logos/manga_raiser.jpg';

const HomePage: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="bg-white">
      {/* Hero Section with Enhanced Gradient and Islamic Pattern */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0" style={{ 
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40zm0-40h20v20H40V0zm20 0h20v20H60V0zm0 20h20v20H60V20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '80px 80px',
            animation: 'moveBackground 30s linear infinite'
          }}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 text-center md:text-right mb-10 md:mb-0 animate-fade-in">
              <h1 className="text-5xl font-bold mb-6">راكان الجعفري</h1>
              <h2 className="text-3xl font-semibold mb-8">رئيس مجلس إدارة بركار</h2>
              <p className="text-xl leading-relaxed">
                رائد أعمال متخصص في ابتكار، تأسيس، وتطوير المشاريع من الفكرة إلى السوق.
                أبني العلامات التجارية، وأصمم الهياكل التي تحوّل الفكرة إلى كيان قابل للنمو والتوسع.
                أُركّز على المشاريع المبتكرة، وأؤمن أن ريادة الأعمال تبدأ من فكرة، وتستمر على نهج.
              </p>
              <div className="mt-10 flex flex-wrap justify-center md:justify-end gap-4">
                <Link 
                  to="/services" 
                  className="btn-primary bg-white text-primary hover:bg-gray-100 px-8 py-3 rounded-md font-medium transition duration-300"
                >
                  خدماتي
                </Link>
                <Link 
                  to="/book-consultation" 
                  className="btn-primary bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-3 rounded-md font-medium transition duration-300"
                >
                  حجز استشارة
                </Link>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center md:justify-end animate-slide-up">
              <div 
                className="relative"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <div className="absolute -inset-4 bg-white/20 rounded-full blur-md animate-pulse"></div>
                <img 
                  src={profileImage} 
                  alt="راكان الجعفري" 
                  className="profile-image w-64 h-64 md:w-80 md:h-80 object-cover rounded-full shadow-xl relative z-10"
                />
                <div 
                  className={`absolute inset-0 bg-primary bg-opacity-20 rounded-full transition-opacity duration-300 z-20 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Links */}
      <div className="py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/services" className="flex items-center bg-white px-4 py-2 rounded-md shadow-sm hover:shadow-md transition duration-300">
              <span className="text-primary font-medium">الخدمات</span>
              <svg className="h-5 w-5 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </Link>
            <Link to="/barkar-projects" className="flex items-center bg-white px-4 py-2 rounded-md shadow-sm hover:shadow-md transition duration-300">
              <span className="text-primary font-medium">مشروع بركار</span>
              <svg className="h-5 w-5 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </Link>
            <Link to="/rakan-box" className="flex items-center bg-white px-4 py-2 rounded-md shadow-sm hover:shadow-md transition duration-300">
              <span className="text-primary font-medium">الصندوق الراكاني</span>
              <svg className="h-5 w-5 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </Link>
            <Link to="/side-projects" className="flex items-center bg-white px-4 py-2 rounded-md shadow-sm hover:shadow-md transition duration-300">
              <span className="text-primary font-medium">أعمالي الجانبية</span>
              <svg className="h-5 w-5 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </Link>
            <Link to="/contact" className="flex items-center bg-white px-4 py-2 rounded-md shadow-sm hover:shadow-md transition duration-300">
              <span className="text-primary font-medium">تواصل معي</span>
              <svg className="h-5 w-5 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>

      {/* Services Overview */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">خدماتي المتميزة</h2>
          <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-12">
            أقدم مجموعة من الخدمات الاحترافية المتخصصة في مجال ريادة الأعمال وتطوير المشاريع
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service 1 */}
            <div className="service-card bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition duration-300">
              <div className="text-primary text-4xl mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">استشارات ريادية</h3>
              <p className="text-gray-600 mb-4">
                استشارات عملية في قطاع ريادة الأعمال والمشاريع، تشمل التأسيس، التخطيط، وتصميم النماذج القابلة للنمو.
              </p>
              <Link to="/services" className="text-primary hover:text-primary-dark font-medium flex items-center">
                تعرف على المزيد
                <svg className="h-5 w-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </Link>
            </div>

            {/* Service 2 */}
            <div className="service-card bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition duration-300">
              <div className="text-primary text-4xl mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">تأسيس وتطوير المشاريع</h3>
              <p className="text-gray-600 mb-4">
                خبرة واسعة في تأسيس المشاريع من بداياتها، وتحويل الأفكار إلى نماذج أعمال واقعية وقابلة للنمو.
              </p>
              <Link to="/services" className="text-primary hover:text-primary-dark font-medium flex items-center">
                تعرف على المزيد
                <svg className="h-5 w-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </Link>
            </div>

            {/* Service 3 */}
            <div className="service-card bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition duration-300">
              <div className="text-primary text-4xl mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">بناء العلامات التجارية</h3>
              <p className="text-gray-600 mb-4">
                تصميم وبناء العلامات التجارية من الصفر، بدءاً من تحديد الهوية وصياغة الرؤية وحتى الظهور في السوق.
              </p>
              <Link to="/services" className="text-primary hover:text-primary-dark font-medium flex items-center">
                تعرف على المزيد
                <svg className="h-5 w-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Projects - Only Barkar */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">مشروعي الرئيسي</h2>
          <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-12">
            مشروع بركار هو المشروع الرئيسي الذي أسسته وأديره، ويعكس رؤيتي في ريادة الأعمال والابتكار
          </p>
          
          <div className="max-w-3xl mx-auto">
            {/* Barkar Project */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-300 hover:scale-105">
              <div className="h-48 bg-gradient-to-r from-primary to-primary-dark flex items-center justify-center">
                <img src={barkarLogo} alt="شعار بركار" className="h-32 object-contain" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">مشروع بركار</h3>
                <p className="text-gray-600 mb-4">
                  كيان تقني يضم تحت مظلته عدة مشاريع وبرامج تعمل على الأتمتة والتحول الرقمي، وتخدم الأفراد والمنشآت عبر أدوات تمكينية ذكية.
                </p>
                <Link to="/barkar-projects" className="inline-block bg-primary text-white hover:bg-primary-dark px-4 py-2 rounded-md font-medium transition duration-300">
                  اكتشف المزيد
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Side Projects Section */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">أعمالي الجانبية</h2>
          <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-12">
            بالإضافة إلى مشروعي الرئيسي، أقوم بمجموعة من الأعمال الجانبية المتنوعة
          </p>
          
          <div className="max-w-3xl mx-auto">
            {/* Manga Raiser Project */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-64 bg-gray-100 flex items-center justify-center">
                <img src={mangaRaiserCover} alt="غلاف مانجا رايسر" className="h-full w-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">مانجا رايسر</h3>
                <p className="text-gray-600 mb-4">
                  قصة خيال وإثارة وأكشن ومغامرات ورعب من تأليفي ورسمي، تدور أحداثها في عالم تختلط فيه الاحتمالات وتتغير فيه طبيعة العالم.
                </p>
                <Link to="/side-projects" className="text-primary hover:text-primary-dark font-medium flex items-center">
                  اكتشف المزيد
                  <svg className="h-5 w-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Rakan Box */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-primary to-primary-dark rounded-xl overflow-hidden shadow-xl">
            <div className="p-8 md:p-12 text-white">
              <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-2/3 mb-8 md:mb-0">
                  <h2 className="text-3xl font-bold mb-6">الصندوق الراكاني</h2>
                  <p className="text-xl mb-6">
                    المكان الذي يحتضن إرثي الفكري والمعرفي، حيث أجمع بين كل ما حملته الأيام من علوم، نصوص، أفكار، ومناقشات في مجالات شتى تخدم الإنسان في دينه ودنياه.
                  </p>
                  <Link to="/rakan-box" className="inline-block bg-white text-primary hover:bg-gray-100 px-6 py-3 rounded-md font-medium transition duration-300 shadow-md">
                    استكشف الصندوق الراكاني
                  </Link>
                </div>
                <div className="md:w-1/3 flex justify-center">
                  <div className="w-48 h-48 bg-white bg-opacity-10 rounded-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">هل تبحث عن استشارة متخصصة؟</h2>
          <p className="text-xl max-w-3xl mx-auto mb-8">
            أنا هنا لمساعدتك في تطوير مشروعك أو فكرتك. احجز استشارة الآن وسنعمل معاً على تحقيق أهدافك.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/book-consultation" className="btn-primary bg-white text-primary hover:bg-gray-100 px-8 py-3 rounded-md font-medium transition duration-300">
              حجز استشارة
            </Link>
            <Link to="/contact" className="btn-primary bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-3 rounded-md font-medium transition duration-300">
              تواصل معي
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
